/* TAG Drop 02 - motion.
   1. Entrance reveals (IntersectionObserver, with a safety net).
   2. Light scroll parallax via --para-y.
   3. --tag-energy: scroll speed 0..1 published to CSS so the heatwave layer
      can react without any per-frame JS styling.
   4. Tap shockwave rings inside any [data-lattice] host.
   The .tagx-motion flag is set here so a failed load never leaves content hidden. */
(function () {
  var root = document.documentElement;
  root.classList.add('tagx-motion');

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveals ---------- */
  function reveals() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < innerHeight * 1.2) el.classList.add('is-in');
      });
    }, 2500);
  }

  /* ---------- energy + parallax ---------- */
  function kinetics() {
    if (reduce) return;
    var paraEls = [].slice.call(document.querySelectorAll('[data-para]'));
    var lowMem = (navigator.deviceMemory || 4) <= 2;
    var lastY = window.scrollY || 0, target = 0, energy = 0, raf = 0, lastT = performance.now();

    function frame(now) {
      raf = 0;
      var dt = Math.min(0.05, Math.max(0.001, (now - lastT) / 1000));
      lastT = now;

      var y = window.scrollY || 0;
      var pxps = Math.abs(y - lastY) / dt;
      lastY = y;
      target = Math.max(target * 0.9, Math.min(1, pxps / 2000));
      energy += (target - energy) * 0.2;
      root.style.setProperty('--tag-energy', energy.toFixed(3));

      if (!lowMem) {
        var vh = innerHeight;
        paraEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var off = (r.top + r.height / 2 - vh / 2) / vh;
          var sp = parseFloat(el.dataset.para) || 0.08;
          el.style.setProperty('--para-y', (off * sp * -100).toFixed(2) + 'px');
        });
      }

      if (energy > 0.003 || target > 0.003) raf = requestAnimationFrame(frame);
    }
    function kick() { if (!raf) { lastT = performance.now(); raf = requestAnimationFrame(frame); } }
    addEventListener('scroll', kick, { passive: true });
    addEventListener('resize', kick, { passive: true });
    kick();
  }

  /* ---------- tap shockwaves ---------- */
  function rings() {
    if (reduce) return;
    document.querySelectorAll('[data-lattice]').forEach(function (host) {
      if (host.dataset.ringsOn) return;
      host.dataset.ringsOn = '1';
      var zone = host.parentElement || host;
      function drop(e) {
        if (host.querySelectorAll('.tagx-lat__ring').length > 2) return;
        var pt = e.touches && e.touches[0] ? e.touches[0] : e;
        var r = host.getBoundingClientRect();
        var el = document.createElement('span');
        el.className = 'tagx-lat__ring';
        el.style.setProperty('--rx', (pt.clientX - r.left) + 'px');
        el.style.setProperty('--ry', (pt.clientY - r.top) + 'px');
        host.appendChild(el);
        setTimeout(function () { el.remove(); }, 950);
      }
      zone.addEventListener('pointerdown', drop, { passive: true });
      zone.addEventListener('touchstart', drop, { passive: true });
    });
  }

  function init() { reveals(); kinetics(); rings(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
